export default __webpack_public_path__ + "static/cristal-b4dfe9b900e7e2f9d950c0b720d25934.gif";